import { ModulesMap } from '@/config/data/modulesMaps'
import CropsApi from '@/services/apiServiceModules/cropsApi'
import DataTransferModule from '@/services/dataTransferModule'

const cropsApi = new CropsApi()

export default class CropsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.CROPS, cropsApi, { useCache: true })
	}

	getFilteredCrops(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getEntities(companyId, query)
				.then((res) => {
					if (query?.year) {
						return resolve(res.filter((crop) => +crop.year === +query.year))
					}
					if (query?.years) {
						return resolve(res.filter((el) => query.years.find((cropYear) => +el.year === +cropYear)))
					}
					return resolve(res)
				})
				.catch(reject)
		})
	}

	getFilteredBasedCrops(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getBasedEntities(companyId, query)
				.then((res) => {
					if (query?.year) {
						return resolve(res.filter((el) => el.year === query.year))
					}
					return resolve(res)
				})
				.catch(reject)
		})
	}

	getFilteredExtendedCrops(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getExtendedEntities(companyId, query)
				.then((res) => {
					if (query?.year) {
						return resolve(res.filter((el) => el.year === query.year))
					}
					return resolve(res)
				})
				.catch(reject)
		})
	}
}
